//
// ███████╗████████╗ █████╗ ████████╗███████╗
// ██╔════╝╚══██╔══╝██╔══██╗╚══██╔══╝██╔════╝
// ███████╗   ██║   ███████║   ██║   █████╗
// ╚════██║   ██║   ██╔══██║   ██║   ██╔══╝
// ███████║   ██║   ██║  ██║   ██║   ███████╗
// ╚══════╝   ╚═╝   ╚═╝  ╚═╝   ╚═╝   ╚══════╝
//
const state = {

}

//
//  ██████╗ ███████╗████████╗████████╗███████╗██████╗ ███████╗
// ██╔════╝ ██╔════╝╚══██╔══╝╚══██╔══╝██╔════╝██╔══██╗██╔════╝
// ██║  ███╗█████╗     ██║      ██║   █████╗  ██████╔╝███████╗
// ██║   ██║██╔══╝     ██║      ██║   ██╔══╝  ██╔══██╗╚════██║
// ╚██████╔╝███████╗   ██║      ██║   ███████╗██║  ██║███████║
//  ╚═════╝ ╚══════╝   ╚═╝      ╚═╝   ╚══════╝╚═╝  ╚═╝╚══════╝
//
const getters = {

}

//
// ███╗   ███╗██╗   ██╗████████╗ █████╗ ████████╗██╗ ██████╗ ███╗   ██╗███████╗
// ████╗ ████║██║   ██║╚══██╔══╝██╔══██╗╚══██╔══╝██║██╔═══██╗████╗  ██║██╔════╝
// ██╔████╔██║██║   ██║   ██║   ███████║   ██║   ██║██║   ██║██╔██╗ ██║███████╗
// ██║╚██╔╝██║██║   ██║   ██║   ██╔══██║   ██║   ██║██║   ██║██║╚██╗██║╚════██║
// ██║ ╚═╝ ██║╚██████╔╝   ██║   ██║  ██║   ██║   ██║╚██████╔╝██║ ╚████║███████║
// ╚═╝     ╚═╝ ╚═════╝    ╚═╝   ╚═╝  ╚═╝   ╚═╝   ╚═╝ ╚═════╝ ╚═╝  ╚═══╝╚══════╝
//
const mutations = {

}

//
//  █████╗  ██████╗████████╗██╗ ██████╗ ███╗   ██╗███████╗
// ██╔══██╗██╔════╝╚══██╔══╝██║██╔═══██╗████╗  ██║██╔════╝
// ███████║██║        ██║   ██║██║   ██║██╔██╗ ██║███████╗
// ██╔══██║██║        ██║   ██║██║   ██║██║╚██╗██║╚════██║
// ██║  ██║╚██████╗   ██║   ██║╚██████╔╝██║ ╚████║███████║
// ╚═╝  ╚═╝ ╚═════╝   ╚═╝   ╚═╝ ╚═════╝ ╚═╝  ╚═══╝╚══════╝
//
const actions = {

  successMessage ({ state }, payload) {
    this._vm.$snotify.success(payload.message, payload.site_name)
  },

  failedMessage ({ state }, payload) {
    this._vm.$snotify.error(payload.message, payload.site_name)
  },

  coreUpdateSuccess ({ dispatch }, payload) {
    dispatch('successMessage', payload)
    dispatch('siteUpdate', payload)
  },

  coreUpdateFailed ({ dispatch }, payload) {
    dispatch('failedMessage', payload)
    dispatch('siteUpdate', payload)
  },

  siteUpdateSuccess ({ dispatch }, payload) {
    dispatch('successMessage', payload)
    dispatch('siteUpdate', payload)
  },

  siteUpdateFailed ({ dispatch }, payload) {
    dispatch('failedMessage', payload)
    dispatch('siteUpdate', payload)
  },

  siteUpdate ({ dispatch }, payload) {
    // Refresh data
    const newPayload = {
      id: payload.site_id,
      type: 'update',
      subtype: 'site',
      site_id: payload.site_id,
      result: payload.result,
      process_state_site: payload.process_state_site
    }

    dispatch('site/afterProcess', newPayload, { root: true })
  },

  extensionUpdateSuccess ({ dispatch }, payload) {
    dispatch('successMessage', payload)
    dispatch('siteUpdate', payload)
    dispatch('extensionUpdate', payload)
  },

  extensionUpdateFailed ({ dispatch }, payload) {
    dispatch('failedMessage', payload)
    dispatch('siteUpdate', payload)
    dispatch('extensionUpdate', payload)
  },

  extensionUpdate ({ dispatch }, payload) {
    const newPayload = {
      id: payload.id,
      type: 'update',
      subtype: 'extension',
      extension_id: payload.id,
      site_id: payload.site_id,
      result: 'success',
      process_state_extension: payload.process_state_extension,
      process_state_site: payload.process_state_site
    }

    dispatch('updates/afterProcess', newPayload, { root: true })
  },

  coreUpdateProgress ({ commit }, payload) {
    if (payload.progress === 100) {
      commit('progress/resetCoreUpdateProgress', payload.site_id, { root: true })

      return
    }

    commit('progress/setCoreUpdateProgress', { siteId: payload.site_id, progress: payload.progress }, { root: true })
  },

  backupProgress ({ commit }, payload) {
    if (payload.progress === 100) {
      commit('progress/resetBackupProgress', payload.site_id, { root: true })

      return
    }

    commit('progress/setBackupProgress', { siteId: payload.site_id, progress: payload.progress }, { root: true })
  },

  backupFailed ({ commit, dispatch }, payload) {
    dispatch('failedMessage', payload)
    commit('progress/resetBackupProgress', payload.site_id, { root: true })
    dispatch('updateLocalStore', payload)
  },

  backupFinished ({ commit, dispatch }, payload) {
    dispatch('successMessage', payload)
    commit('progress/resetBackupProgress', payload.site_id, { root: true })
    dispatch('updateLocalStore', payload)
  },

  backupStarted ({ dispatch }, payload) {
    dispatch('successMessage', payload)
  },

  backupTestFinished ({ commit, dispatch }, payload) {
    dispatch('successMessage', payload)
    commit('progress/resetBackupTestProgress', payload.id, { root: true })
    dispatch('updateLocalStore', payload)
  },

  backupTestStarted ({ dispatch }, payload) {
    dispatch('successMessage', payload)
  },

  backupTestProgress ({ commit }, payload) {
    if (payload.progress === 100) {
      commit('progress/resetBackupTestProgress', payload.backup_id, { root: true })

      return
    }

    commit('progress/setBackupTestProgress', { backupId: payload.backup_id, progress: payload.progress }, { root: true })
  },

  backupAuditFinished ({ commit, dispatch }, payload) {
    dispatch('successMessage', payload)
    dispatch('updateLocalStore', payload)
  },

  backupAuditStarted ({ dispatch }, payload) {
    dispatch('successMessage', payload)
  },

  backupAuditProgress ({ commit }, payload) {
    if (payload.progress === 100) {
      commit('progress/resetAuditProgress', payload.audit_id, { root: true })

      return
    }

    commit('progress/setAuditProgress', { auditId: payload.audit_id, progress: payload.progress }, { root: true })
  },

  updateLocalStore ({ dispatch }, payload) {
    this._vm.axios.get('/api/site/' + payload.site_id)
      .then(
        response => {
          let result = {
            'data': response.data.data,
            'context': {
              'source': 'remote',
              'type': 'site',
              'site_id': payload.site_id
            }
          }
          dispatch('site/updateLocalStore', result, { root: true })
        })
      .catch(
        () => {
          this._vm.$snotify.error('Error while fetching site data - try again or contact support')
        })
  },

  newSiteCreated ({ dispatch }, payload) {
    dispatch('successMessage', payload)
    dispatch('updateLocalStore', payload)
  },

  siteDown ({ dispatch }, payload) {
    dispatch('failedMessage', payload)
  },

  siteUp ({ dispatch }, payload) {
    dispatch('successMessage', payload)
  }

}

//
// ███████╗██╗  ██╗██████╗  ██████╗ ██████╗ ████████╗
// ██╔════╝╚██╗██╔╝██╔══██╗██╔═══██╗██╔══██╗╚══██╔══╝
// █████╗   ╚███╔╝ ██████╔╝██║   ██║██████╔╝   ██║
// ██╔══╝   ██╔██╗ ██╔═══╝ ██║   ██║██╔══██╗   ██║
// ███████╗██╔╝ ██╗██║     ╚██████╔╝██║  ██║   ██║
// ╚══════╝╚═╝  ╚═╝╚═╝      ╚═════╝ ╚═╝  ╚═╝   ╚═╝
//
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
